import { Draggable } from "react-smooth-dnd";
import styled from "styled-components";

export default styled(Draggable)`
  margin-top: 30px;
`;
